import { createContext } from "react"

export type Risk = {
    projectId: number
    riskId: number
    workstream: string
    workstreamId: number
    workPackage: string
    workPackageId: number
    risk: string
    mitigation: string
    rating: "Low" | "Medium" | "High"
    status: "Closed" | "Cancelled" | "Open"
    date: Date
    raisedBy?: string // Optional field for who raised the risk
    probability: "Low" | "Medium" | "High"
    impact: "Low" | "Medium" | "High"
    owner: string
    userId: string
    notes: string
    displayOnDashboard: boolean
    displayOnStatusReport: boolean
    seen: boolean
    acknowledged: boolean
}

interface RiskContextProps {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    riskTableDemoContent: Risk[];
    setRiskTableDemoContent: (content: Risk[]) => void;
    showPopup: (risk: Risk) => void;
    demoMode: boolean;
    setDemoMode: (mode: boolean) => void;
    rowSelection: {};
    setRowSelection: React.Dispatch<React.SetStateAction<{}>>;
    addRisk: () => void;
}

export const RiskContext = createContext<RiskContextProps>({
    dialogOpen: false,
    setDialogOpen: () => {},
    riskTableDemoContent: [],
    setRiskTableDemoContent: () => {},
    showPopup: () => {},
    demoMode: false,
    setDemoMode: () => {},
    rowSelection: {},
    setRowSelection: () => {},
    addRisk: () => {},
});